import { customTheme } from 'theme/MuiThemeProvider/theme';

export const styles = {
  label: {
    color: customTheme.custom.black.B70,
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: '12px',
    letterSpacing: '0.2px',
  },
};
